import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { reduxForm, Field, reset } from "redux-form";
import { required, url } from "../../constants/formValidators";
import { FormField } from "../../sharedComponents/formField";
import FilterPanel, { PanelBody } from "../../sharedComponents/filterPanel";
import { NotificationManager } from "react-notifications";
import DropZone from "../../sharedComponents/dropZoneWrap";

function AddOrDeleteMotivation({
	show,
	handleClose,
	formType,
	fileType,
	onClickMotivationType,
	handleSubmit,
	submitMotivation,
	motivationId,
	resetForm
}) {
	const [image, setImage] = useState([]);
	const [submitting, setSubmitting] = useState(false);

	useEffect(() => {
		setSubmitting(false);
	}, [image]);

	const validateForm = (values) => {
		setSubmitting(true);
		let data = null;
		if (formType === "Add") {
			if (fileType === "video") {
				data = {
					title: values.title,
					video: values.url
				};
			} else {
				if (image.length) {
					const file = image[0].file;
					data = new FormData();
					data.append("title", values.title);
					data.append("url", values.link);
					data.append("image", file, file.name);
				}
			}
		} else if (formType === "Update") {
			if (fileType === "video") {
				data = {
					title: values.title,
					video: values.url
				};
			} else {
				data = {
					title: values.title,
					url: values.link
				};
			}
		}

		if (fileType === "image" && formType === "Add" && !image.length) {
			NotificationManager.error("Please select an image!", "", 5000);
		} else if (image && image.length && image[0].file && image[0].file.name.length > 100) {
			NotificationManager.error("Image name must be 100 or less", "", 5000);
			setSubmitting(true);
		} else {
			submitMotivation(formType, fileType, data, motivationId);
		}
	};

	const notify = (msg) => {
		switch (msg.type) {
			case "error":
				return NotificationManager.error(msg.text, "", 5000);
			case "success":
				return NotificationManager.success(msg.text, "", 5000);
			default:
			// do nothing
		}
	};

	return (
		<FilterPanel
			className="hide-sub-header"
			show={show}
			toggle={() => {
				resetForm("AddOrupdateMotivation");
				handleClose();
			}}
			title={`${formType} Motivational Content`}
			closeBtn>
			<PanelBody className="d-flex flex-column">
				{formType === "Add" && fileType === null ? (
					<div className="row select-menu">
						<div className="col-6">
							<button
								className="w-100 rounded text-primary-dark p-4"
								onClick={() => onClickMotivationType("image")}>
								<i className="icon icon-picture xl-icon"></i>
								<span className="d-block">Image</span>
							</button>
						</div>
						<div className="col-6">
							<button
								className="w-100 rounded text-primary-dark p-4"
								onClick={() => onClickMotivationType("video")}>
								<i className="icon icon-video xl-icon"></i>
								<span className="d-block">Video</span>
							</button>
						</div>
					</div>
				) : (
						<form className="d-flex flex-column flex-fill h-100" onSubmit={handleSubmit(validateForm)}>
							<div className="flex-fill">
								<div className="row">
									<Field
										label="Title"
										name="title"
										type="text"
										validate={[required]}
										formGroupClass="col-12"
										component={FormField}
										onChange={() => setSubmitting(false)}
									/>
								</div>
								<div className="row">
									{fileType === "image" && formType === "Add" ? (
										<div className="col-12">
											<DropZone
												alert={notify}
												accepts={["jpeg", "jpg", "png"]}
												onAdd={setImage}
												forceReset={null}
												className="w-100 mt-2"
											/>
										</div>
									) : (
											fileType === "video" && (
												<Field
													label="Video Url"
													name="url"
													type="text"
													validate={[required, url]}
													formGroupClass="col-12"
													component={FormField}
													onChange={() => setSubmitting(false)}
												/>
											)
										)}
								</div>
							</div>
							<div className="row mt-2">
								<div className="col-12 text-right">
									{formType === "Add" ? (
										<button type="submit" disabled={submitting} className="btn btn-primary text-uppercase">
											Add
									</button>
									) : (
											<button type="submit" disabled={submitting} className="btn btn-primary text-uppercase">
												Update
									</button>
										)}
								</div>
							</div>
						</form>
					)}
			</PanelBody>
		</FilterPanel>
	);
}

const mapDispatchToProps = { resetForm: reset };

export default reduxForm({
	form: "AddOrupdateMotivation",
	enableReinitialize: true
})(
	connect(
		null,
		mapDispatchToProps
	)(AddOrDeleteMotivation)
);
